import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { AiOutlineCopy } from '@react-icons/all-files/ai/AiOutlineCopy';
import { Container, Image, Spinner } from 'react-bootstrap'
import Table from 'react-bootstrap/Table';
import PartnerHeader from './PartnerHeader';
import TreehouseSelectbox from './TreehouseSelectBox';
import InfiniteScroll from 'react-infinite-scroller';
import { useAuth } from '../../auth/Auth';
import { bg } from '../../../constants/component.constants';
import { changeBodyClassName } from '../../../utils/utils';
import ClassImg from '../../../assets/images/old-letsgo.svg'
import { schoolViewModel } from './school.view.model';
import KidsSectionTable from './KidsSectionTable';
import GuardianInviteModal from './camp_invite/GuardianInviteModal';
import RoundButton from '../../common/RoundButton';
import "./campkids.css";
import InviteModal from './camp_invite/InviteModal';
import { useRecoilState } from 'recoil';
import { stepsEnabledAtom } from '../../../atoms/camp.atom';
const CampKidSection = () => {
  const _PAGE_LIMIT = 7;
  const { fetchAPI, school } = useAuth();
  const [treehousesList, setTreehousesList] = useState([]);
  const [selectedTreehouse, setSelectedTreehouse] = useState('All');
  const [treehouseDetails, setTreehouseDetails] = useState();
  const [treehouseSubscribers, setTreehouseSubscribers] = useState([]);
  const [schoolSubscribers, setSchoolSubscribers] = useState([]);
  const [copiedClass, setCopiedClass] = useState('');
  const [isAll, setIsAll] = useState();
  const [loading, setLoading] = useState(true);
  const [apiLoading, setApiLoading] = useState(false);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [stepsEnabled, setStepsEnabled] = useRecoilState(stepsEnabledAtom);
  const [query, setQuery] = useState({
    limit: _PAGE_LIMIT,
    has_more: true,
  });

  const [treehouseQuery, setTreehouseQuery] = useState({
    limit: _PAGE_LIMIT,
    has_more: true,
  });

  const getTreehouses = () => {
    const params = {
      limit: 99,
    };
    let API =
      school?.user_type === 'school'
        ? schoolViewModel?.getCampMasterTribes
        : schoolViewModel?.getCampCaptainTribes;
    API(school?.id, params)
      .then((res) => {
        setTreehousesList(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getDependents = () => {
    if (selectedTreehouse[0].id && !apiLoading) {
      setApiLoading(true);
      let groups = [selectedTreehouse[0]?.id];
      let previousList = treehouseSubscribers;
      let depQuery = { ...treehouseQuery };
      depQuery.group = selectedTreehouse[0]?.id;
      let API =
        school?.user_type === 'school'
          ? schoolViewModel.getTribeDependents
          : schoolViewModel.getCampCaptainDependents;
      fetchAPI(API, depQuery, previousList, groups)
        .then((res) => {
          ReactDOM.unstable_batchedUpdates(() => {
            setTreehouseSubscribers(res.List);
            setTreehouseQuery(res.query);
            setLoading(false);
            setApiLoading(false);
          });
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
          setApiLoading(false);
        });
    }
  };

  const getSchoolDependents = () => {
    if (selectedTreehouse === 'All' && !apiLoading) {
      setApiLoading(true);
      let groups = [];
      treehousesList.forEach((obj) => groups.push(obj.id));
      let previousList = schoolSubscribers;
      let API =
        school?.user_type === 'school'
          ? schoolViewModel.getCampDependents
          : schoolViewModel.getCampCaptainDependents;
      fetchAPI(API, query, previousList, groups)
        .then((res) => {
          ReactDOM.unstable_batchedUpdates(() => {
            setSchoolSubscribers(res.List);
            setQuery(res.query);
            setLoading(false);
            setApiLoading(false);
          });
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
          setApiLoading(false);
        });
    }
  };

  async function copyTextToClipboard() {
    setCopiedClass(copiedClass === 'copied' ? '' : 'copied');
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(
        `${selectedTreehouse[0]?.group_code}`
      );
    } else {
      return document.execCommand(
        'copy',
        true,
        `${selectedTreehouse[0]?.group_code}`
      );
    }
  }

  useEffect(() => {
    changeBodyClassName([bg.WHITE]);
    getTreehouses();
  }, []);

  useEffect(() => {
    if (treehousesList.length !== 0) {
      getSchoolDependents();
    } else {
      setLoading(false);
    }
  }, [treehousesList]);

  useEffect(() => {
    if (selectedTreehouse === 'All') {
      setLoading(true);
      getSchoolDependents();
      setTreehouseDetails('');
    } else {
      setLoading(true);
      getDependents();
      setTreehouseSubscribers([]);
    }
  }, [selectedTreehouse]);

  useEffect(() => {
    setLoading(true);
    getDependents();
  }, [treehouseDetails]);

  const handleInviteClick = () => {
    setShowInviteModal(true);
  };

  const handleUpdate = () => {
    setTreehouseQuery({
      limit: _PAGE_LIMIT,
      has_more: true,
      group: selectedTreehouse[0]?.id,
    });
    setTreehouseSubscribers([]);
    setApiLoading(true);
    let groups = [];
    let previousList = [];
    let depQuery = {
      limit: _PAGE_LIMIT,
      has_more: true,
      group: selectedTreehouse[0]?.id,
    };
    let API =
      school?.user_type === 'school'
        ? schoolViewModel.getTribeDependents
        : schoolViewModel.getCampCaptainDependents;
    fetchAPI(API, depQuery, previousList, groups)
      .then((res) => {
        ReactDOM.unstable_batchedUpdates(() => {
          setTreehouseSubscribers(res.List);
          setTreehouseQuery(res.query);
          setLoading(false);
          setApiLoading(false);
        });
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setApiLoading(false);
      });
  };

  return (
    <div className="treehouse-details partner-wrapper-main">
      <PartnerHeader />
      <InviteModal
        getData={
          selectedTreehouse !== 'All' ? getDependents : getSchoolDependents
        }
        showModal={showInviteModal}
        setShowModal={setShowInviteModal}
        groupCode={selectedTreehouse[0]?.group_code}
        schoolName={school?.school_name}
      />
      <Container>
        <div className="treehouse-details-inner">
          <div>
            <div className="treehouse-details-header">
              <h4>Tribe details</h4>
              {selectedTreehouse !== 'All' || stepsEnabled ? (
                <>
                  <div className="share-link">
                    <div className={'link-txt ' + copiedClass}>
                      {selectedTreehouse && selectedTreehouse[0]?.group_code}
                      <span className="copy-icon" onClick={copyTextToClipboard}>
                        <AiOutlineCopy />
                      </span>
                    </div>
                  </div>
                  <div className="grade-dropdown">
                    <div className="filter-container">
                      <div className="filter-tag">
                        <RoundButton
                          type="button"
                          label="Invite"
                          className="transparent-button d-sm-block notes-top-btn"
                          onClick={handleInviteClick}
                        />
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                ''
              )}
              <div className="grade-dropdown">
                <div className="filter-container">
                  <div className="filter-tag">
                    <TreehouseSelectbox
                      treehousesList={treehousesList}
                      selectedTreehouse={selectedTreehouse}
                      setSelectedTreehouse={setSelectedTreehouse}
                      setIsAll={setIsAll}
                      setTreehouseQuery={setTreehouseQuery}
                      setSchoolQuery={setQuery}
                      setSchoolSubscribers={setSchoolSubscribers}
                      setTreehouseSubscribers={setTreehouseSubscribers}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="treehouse-right-action">
              <div className="table-container">
                {treehouseSubscribers.length !== 0 ||
                schoolSubscribers.length !== 0 ? (
                  <InfiniteScroll
                    pageStart={0}
                    loadMore={
                      selectedTreehouse !== 'All'
                        ? getDependents
                        : getSchoolDependents
                    }
                    hasMore={
                      selectedTreehouse !== 'All'
                        ? treehouseQuery.has_more
                        : query.has_more
                    }
                    threshold={150}
                    className="home-feed-spinner-wrapper"
                    loader={
                      <Spinner
                        key={0}
                        className="home-feed-spinner"
                        animation="border"
                        variant="info"
                      />
                    }
                  >
                    <Table hover>
                      <thead>
                        <tr>
                          <th>Child</th>
                          <th>Tribe</th>
                          <th>Parent/Guardian</th>
                          <th>Special Camp</th>
                          <th>E-Mail</th>
                          <th>Notes</th>
                        </tr>
                      </thead>
                      <tbody>
                        {treehouseSubscribers &&
                          treehouseSubscribers.map((kid, key) => {
                            return (
                              <React.Fragment key={key}>
                                <KidsSectionTable
                                  kid={kid}
                                  list={treehouseSubscribers}
                                  setList={setTreehouseSubscribers}
                                />
                              </React.Fragment>
                            );
                          })}
                        {schoolSubscribers &&
                          schoolSubscribers.map((kid, key) => {
                            return (
                              <React.Fragment key={key}>
                                <KidsSectionTable
                                  kid={kid}
                                  list={schoolSubscribers}
                                  setList={setSchoolSubscribers}
                                />
                              </React.Fragment>
                            );
                          })}
                      </tbody>
                    </Table>
                  </InfiniteScroll>
                ) : loading ? (
                  <Spinner
                    key={0}
                    className="home-feed-spinner"
                    animation="border"
                    variant="info"
                  />
                ) : (
                  <div className="myroom-creation-container">
                    <div className="choose-class">
                      <Image
                        className="rounded-circle profile-image"
                        src={ClassImg}
                      />
                      Add kids to your Tribe
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
export default CampKidSection;